import { Box, Divider, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Order } from '../../../interfaces/Order/Order';
import { sharedStyles } from '../../../utils/Style';
import { formatCurrency } from '../../../utils/Currency';

interface BreakdownRowProps {
  name: string;
  amount: number;
  link?: string;
  bold?: boolean;
}

const BreakdownRow = (props: BreakdownRowProps) => {
  const name = (
    <Typography
      sx={{
        ...sharedStyles.body1,
        fontWeight: props.bold ? 'bold' : 'normal',
      }}
    >
      {props.name}
    </Typography>
  );
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      {props.link ? (
        <Link to={props.link} target='_blank'>
          {name}
        </Link>
      ) : (
        name
      )}
      <Typography
        sx={{
          ...sharedStyles.body1,
          fontWeight: props.bold ? 'bold' : 'normal',
        }}
      >
        {formatCurrency(props.amount)}
      </Typography>
    </Box>
  );
};

interface PayBreakdownProps {
  order: Order;
  shippingProviderName?: string;
}

export const PayBreakdown = (props: PayBreakdownProps) => {
  const isAppliedOffer = Number.isFinite(props.order.offerID);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        width: '100%',
        maxWidth: 400,
      }}
    >
      <BreakdownRow name='Ara Toplam' amount={props.order.subtotalAmount} />
      <BreakdownRow
        name={props.shippingProviderName ?? 'Kargo Ücreti'}
        amount={props.order.shippingAmount}
      />
      {props.order.discount > 0 && (
        <BreakdownRow
          name={isAppliedOffer ? 'Kampanya' : 'İndirim'}
          link={
            isAppliedOffer ? `/sales/offers/${props.order.offerID}` : undefined
          }
          amount={-props.order.discount}
        />
      )}
      {props.order.pointUsage > 0 && (
        <BreakdownRow name='Puan Kullanımı' amount={-props.order.pointUsage} />
      )}
      <Divider />

      <BreakdownRow bold name='Toplam' amount={props.order.totalAmount} />
    </Box>
  );
};
